module.exports = __webpack_public_path__ + "img/school_xnsz.94afb33d.png";